"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_BASE = "/image/new-version/fabrication/metal-welding/Services";

const SERVICE_CARDS = [
	{ keyPrefix: "metalWeldingServicesCard1", image: `${IMAGE_BASE}/tlg-welding-tungsten-inert-gas.webp` },
	{ keyPrefix: "metalWeldingServicesCard2", image: `${IMAGE_BASE}/co2-mig-welding-metal-inert-gas.webp` },
	{ keyPrefix: "metalWeldingServicesCard3", image: `${IMAGE_BASE}/laser-welding-services.webp` },
	{ keyPrefix: "metalWeldingServicesCard4", image: `${IMAGE_BASE}/spot-welding.webp` },
	{ keyPrefix: "metalWeldingServicesCard5", image: `${IMAGE_BASE}/brazing-welding.webp` },
	{ keyPrefix: "metalWeldingServicesCard6", image: `${IMAGE_BASE}/custom-welding-fabrication.webp` },
] as const;

export default function MetalWeldingServices() {
	const t = useTranslations("new-welding");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("metalWeldingServicesTitle")}
					</h2>
					<p className="mt-3 text-sm leading-relaxed text-black sm:mt-4 md:text-base">
						{t("metalWeldingServicesDesc")}
					</p>
				</header>

				<div className="grid grid-cols-1 gap-6 sm:gap-8 md:grid-cols-2 lg:grid-cols-3">
					{SERVICE_CARDS.map((card) => (
						<article
							key={card.keyPrefix}
							className="flex flex-col overflow-hidden rounded-xl border-2 border-[#7d7d7d] bg-white"
						>
							<div className="relative aspect-[4/2] w-full shrink-0 overflow-hidden bg-gray-100">
								<Image
									src={card.image}
									alt={t(`${card.keyPrefix}Alt`)}
									fill
									className="object-cover"
									sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
								/>
							</div>
							<div className="flex flex-1 flex-col p-5 text-left sm:p-6">
								<h3 className="text-lg font-bold text-black sm:text-xl">{t(`${card.keyPrefix}Title`)}</h3>
								<p className="mt-2 text-sm leading-relaxed text-black md:mt-3 md:text-base">
									{t(`${card.keyPrefix}Desc`)}
								</p>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
